<template>
  <div class="event activity">
    <div class="event-header">
      <span class="event-date">{{ activity.datetime.date() }}</span>
      <span class="event-name">AKTYWNOŚĆ</span>
      <span class="event-actions">
        <v-icon dark class="click-effect" v-if="isActiveRunner" v-tooltip="'Edytuj'" @click.stop="$emit('edit-activity')">edit</v-icon>
        <v-icon dark class="click-effect" v-if="isActiveRunner" v-tooltip="'Usuń'" @click.stop="$emit('remove-activity')">delete</v-icon>
      </span>
    </div>
    <div class="event-content">
      <ul>
        <li><i v-tooltip="'Opis'" class="text-icon mr-1">O</i> {{activity.runner_additional_info }}</li>
        <li><i v-tooltip="'Dystans'" class="fi flaticon-road-1 mr-1"></i> {{activity.total_distance_done }}</li>
      </ul>
    </div>
    <div class="event-footer">
      <span></span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isActiveRunner'])
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/ActivitySmall.vue